"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateLocationDto = instanceOfUpdateLocationDto;
exports.UpdateLocationDtoFromJSON = UpdateLocationDtoFromJSON;
exports.UpdateLocationDtoFromJSONTyped = UpdateLocationDtoFromJSONTyped;
exports.UpdateLocationDtoToJSON = UpdateLocationDtoToJSON;
exports.UpdateLocationDtoToJSONTyped = UpdateLocationDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateLocationDto interface.
 */
function instanceOfUpdateLocationDto(value) {
    if (!('latitude' in value) || value['latitude'] === undefined)
        return false;
    if (!('longitude' in value) || value['longitude'] === undefined)
        return false;
    return true;
}
function UpdateLocationDtoFromJSON(json) {
    return UpdateLocationDtoFromJSONTyped(json, false);
}
function UpdateLocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}
function UpdateLocationDtoToJSON(json) {
    return UpdateLocationDtoToJSONTyped(json, false);
}
function UpdateLocationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}
